import {
  withRequestRetry,
  defaultFetchOptions,
  _handleJsonResponse,
  RequestErrorHandler,
} from './DataExtraction';
import { SAVE_OUTCOME_DETAIL_ROUTE, tokenizeRoute } from 'query/routes';

export const saveOutcomeDetail = async (
  outcomeDetailValue: string,
  outcome_id: string,
  outcome_detail_id: string,
  onError?: RequestErrorHandler
) => {
  return withRequestRetry(
    () => _saveOutcomeDetail(outcomeDetailValue, outcome_id, outcome_detail_id),
    onError
  );
};

const _saveOutcomeDetail = async (
  value: string,
  outcome_id: string,
  outcome_detail_id: string
) => {
  const url = tokenizeRoute(SAVE_OUTCOME_DETAIL_ROUTE, {
    outcome_id: outcome_id,
  });
  const requestBody = {
    value,
    outcome_detail_id,
  };

  return fetch(url.toString(), {
    method: 'PUT',
    body: JSON.stringify(requestBody),
    ...defaultFetchOptions(),
  }).then((response) => {
    return _handleJsonResponse(response);
  });
};
